/**
 * Persisted preference for 1 vs 2 quiz cards per row on narrow viewports (< md).
 * Shared by solo quiz list and PvP lobby so the choice stays in sync.
 */
export const MOBILE_QUIZ_CARD_COLS_STORAGE_KEY = 'quizter_pvp_lobby_mobile_card_cols';
